import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE, LANGUAGE_ENUM } from "./i18consts";
import Backend from "i18next-http-backend";

const baseUrl = location.origin;

const languageRegExp = /\/(de|en)\//; 
const match = window.location.href.match(languageRegExp); 
const languageFromUrl = match ? match[1] : DEFAULT_LANGUAGE; 

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    backend: {
      loadPath: `${baseUrl}/admin/translations?locale=${languageFromUrl}`,
    },
    ns: [`common`],
    defaultNS: `common`,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGE_ENUM.map((c) => c.key),
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;